import React from 'react'
import "./Healthcare.scss"
import { BRAND_NAME, getExampleProviderPair, WHY_CHOOSE_BULLETS } from "../../content/landingContent"
import doc from "../../../src/Assets/doc.png"
import mdoc from "../../../src/Assets/mdoctor.png"
import fdoc from "../../../src/Assets/fdoctor.png"
import Polygon from "../../../src/Assets/Polygon.png"
import Vector from "../../../src/Assets/Vectoro.png"
import logodone from  "../../../src/Assets/logodone.png"
import haflogoc from  "../../../src/Assets/haflogoc.png"

export default function Healthcare() {
    const examples = getExampleProviderPair()
    return (
        <div>
            <div className="backcolor">
                <figure className='Pol_ygon'><img src={Polygon} alt="" /></figure>
                <figure className='logo_done'><img src={logodone} alt="" /></figure>
                <div className="container WHY">
                    <div className="why_flex">
                        <div className="Why ">

                            <div className="why_chose">
                                <h2>Why <span className='wgreen'>choose</span> {BRAND_NAME} for</h2>
                                <h2>your <span className='wgreen'>healthcare</span>?</h2>
                            </div>

                            <div className="Experienced_flx">
                                <div className="numbar">
                                    <p className='round_one'>01</p>
                                </div>
                                <div className="word">
                                    <p className='exper'>Safe & Private</p>
                                    <p className='our_team'>{WHY_CHOOSE_BULLETS.safe}</p>
                                </div>
                            </div>

                            <div className="Experienced_flx">
                                <div className="numbar">
                                    <p className='round_two'>02</p>
                                </div>
                                <div className="word">
                                    <p className='exper'>Clear Pricing</p>
                                    <p className='our_team'>{WHY_CHOOSE_BULLETS.clearPricing}</p>
                                </div>
                            </div>
                            <div className="Experienced_flx">
                                <div className="numbar">
                                    <p className='round_three'>03</p>
                                </div>
                                <div className="word">
                                    <p className='exper'>Trusted Care</p>
                                    <p className='our_team'>{WHY_CHOOSE_BULLETS.trusted}</p>
                                </div>
                            </div>
                            <div className="Experienced_flx">
                                <div className="numbar">
                                    <p className='round_four'>04</p>
                                </div>
                                <div className="word">
                                    <p className='exper'>Your Choice</p>
                                    <p className='our_team'>{WHY_CHOOSE_BULLETS.yourChoice}</p>
                                </div>
                            </div>
                        </div>

                        <span className='Vec_tor'>
                            <img src={Vector} alt="" />
                        </span>

                         <span className='Vec_tor_haf'>
                            <img src={haflogoc} alt="" />
                        </span>
                        <div className="doctorfm_img BID">
                            <figure className='child_doc'>
                                <img src={doc} alt="" />
                            </figure>
                        </div>
                    </div>





                    <div className="Available">
                        <div className="Avail_able">
                            <h3 className='avil'>Who responds to your surgery request</h3>
                            <p className='chos'>Sample roles shown for understanding; actual doctors and hospitals vary by case and city.</p>
                            <div className="doc_flex roy">
                                <div className="dr_roy">
                                    <span><img src={mdoc} alt="" /></span>
                                </div>
                                <div className="dr_shan">
                                    <h3>{examples.a.name}</h3>
                                    <p>{examples.a.role}</p>
                                </div>
                            </div>

                            <div className="doc_flex">
                                <div className="dr_das">
                                    <span><img src={fdoc} alt="" /></span>
                                </div>
                                <div className="dr_shan">
                                    <h3>{examples.b.name}</h3>
                                    <p>{examples.b.role}</p>
                                </div>
                            </div>


                        </div>
                    </div>



                </div>
              
            </div>
        </div>
    )
}
